import React from "react";
import { merge } from "glamor";
import theme from "styles/theme";
import DragIcon from "material-ui/svg-icons/editor/drag-handle";
//import { SortableHandle } from 'react-sortable-hoc';

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge({
            zIndex: 4,
            position: "absolute",
            top: "-6px",
            left: "0px",
            height: "38px",
            width: "40px",
            padding: "4px",
            cursor: "move",
            transition: "all .12s ease-in",
        });
    }
    return styles;
};

export const DragHandleSection = ({ style = {}, iconStyle = {} }) => (
    <div {...getStyles()} style={style}>
        <DragIcon style={iconStyle} color={theme.palette.darkGrey} />
    </div>
);

const DragHandle = ({ style, iconStyle = {}, connectDragSource }) =>
    connectDragSource(
        <div {...getStyles()} style={style}>
            <DragIcon style={iconStyle} color={theme.palette.darkGrey} />
        </div>
    );

export default DragHandle;
